import { Component, Vue, Watch } from 'vue-property-decorator';
import { IValidations, IValidator } from '@/interfaces';



@Component
export class FormMixinComponent<T> extends Vue {
  /**
   * If we should watch for validations when they change
   */
  public shouldValidate = false;

  /**
   * The model that is being tracked by the view
   */
  public model!: T;

  /**
   * The validator for this model
   */
  public validator!:  IValidator<T>;

  /**
   * The validations that should be presented to the user
   */
  public validations!: IValidations<T> | null;

  /**
   * The callback method when this form needs to be submitted
   */
  public async submit() {
    this.shouldValidate = true;
    const validations = this.validator.isValid(this.model);
    if (validations === true) {
      this.shouldValidate = false;
      this.$emit('submit', this.model);
    } else {
      this.validations = validations;
    }
  }

  /**
   * Helper method to get the validation text that should be displayed to the user when the validation is triggered
   * 
   * @param key The key we want to get the validations from
   */
  public getValidationText(key: keyof T) {
    return (this.validations !== null ? this.validations[key] : null) ?? '';
  }

  /**
   * Watcher method to check when the model is updated
   * 
   * @param newModel The new model that is updated
   */
  @Watch('model', { deep: true })
  public onModelUpdate(newModel: T) {
    if (this.shouldValidate) {
      const validations = this.validator.isValid(newModel);
      this.validations = validations !== true ? validations : null;
    }
  }
}